var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcProjectChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 47,
    viewBox: "0 0 51 47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "17.844%",
    x2: "100%",
    y2: "81.056%",
    id: "6vfn726gya"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5C88FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4FD8CC",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.535.524c5.232 0 8.72.847 11.73 2.457a16.623 16.623 0 0 1 6.916 6.916c1.61 3.01 2.457 6.498 2.457 11.73v2.788c0 5.231-.847 8.72-2.457 11.73a16.623 16.623 0 0 1-6.916 6.915c-3.01 1.61-6.498 2.458-11.73 2.458h-6.908c-5.232 0-8.72-.848-11.73-2.458a16.623 16.623 0 0 1-6.916-6.915c-1.61-3.01-2.457-6.499-2.457-11.73v-2.788c0-5.232.847-8.72 2.457-11.73A16.623 16.623 0 0 1 9.897 2.98c3.01-1.61 6.498-2.457 11.73-2.457z",
    stroke: "url(#6vfn726gya)",
    strokeWidth: 1.048,
    transform: "translate(.044)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5C88FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.08 29.047a10.597 10.597 0 0 1-3.076-6.458 6.79 6.79 0 0 0-1.436 4.202 6.887 6.887 0 0 0 .645 2.897l-.868 2.563c-.15.44-.04.918.284 1.248a1.175 1.175 0 0 0 1.23.288l2.526-.88a6.624 6.624 0 0 0 2.854.654 6.571 6.571 0 0 0 4.21-1.512c-2.394-.22-4.628-1.266-6.37-3.002z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.893 29.29-1.26-3.72a9.44 9.44 0 0 0 .93-4.07 9.313 9.313 0 0 0-2.631-6.526c-1.701-1.757-3.968-2.746-6.383-2.785a9.024 9.024 0 0 0-6.627 2.722 9.298 9.298 0 0 0-2.683 6.725 9.3 9.3 0 0 0 2.745 6.476c1.729 1.723 4.007 2.67 6.417 2.67h.014a9.081 9.081 0 0 0 4.012-.943l3.666 1.278a1.397 1.397 0 0 0 1.462-.343c.386-.391.515-.96.338-1.483zm-8.607-4.578h-4.731a.65.65 0 0 1-.646-.656.65.65 0 0 1 .646-.655h4.731a.65.65 0 0 1 .646.655.65.65 0 0 1-.646.656zm2.96-2.695h-7.691a.65.65 0 0 1-.646-.655.65.65 0 0 1 .646-.655h7.692a.65.65 0 0 1 .646.655.65.65 0 0 1-.646.655zm0-2.694h-7.691a.65.65 0 0 1-.646-.655.65.65 0 0 1 .646-.655h7.692a.65.65 0 0 1 .646.655.65.65 0 0 1-.646.655z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProjectChat);
export default __webpack_public_path__ + "static/media/ic_project_chat.c0205af6f7305f602b2cdeec73590d15.svg";
export { ForwardRef as ReactComponent };